export default __webpack_public_path__ + "static/media/Windy_01.fa48957c.png";